import { HttpErrorResponse } from '@angular/common/http';
import { AbstractControl } from '@angular/forms';

export const INVALID_2FA_LOGIN_MESSAGE = 'Invalid 2FA code.';

export const INVALID_TWO_FACTOR_CODE_ERROR_KEY = 'invalidTwoFactorCode';

export function isInvalid2faLoginHttpError(error: HttpErrorResponse): boolean {
  const body = error.error;
  return (
    typeof body === 'string' && body.trim() === INVALID_2FA_LOGIN_MESSAGE
  );
}

export function applyInvalidTwoFactorCodeError(control: AbstractControl): void {
  control.setErrors({
    ...control.errors,
    [INVALID_TWO_FACTOR_CODE_ERROR_KEY]: true,
  });
  control.markAsTouched();
}

export function clearInvalidTwoFactorCodeError(control: AbstractControl): void {
  if (!control.hasError(INVALID_TWO_FACTOR_CODE_ERROR_KEY)) {
    return;
  }
  const { [INVALID_TWO_FACTOR_CODE_ERROR_KEY]: _removed, ...rest } =
    control.errors || {};
  control.setErrors(Object.keys(rest).length ? rest : null);
}
